<template>
  <div class="page-popu">
    <div class="heaer-text">管理推广报表</div>
    <div class="filter">
      <el-select
        multiple
        collapse-tags
        filterable
        class="filter-item"
        v-model="formSearch.deliverySubIds"
        placeholder="请选择投放主体"
      >
        <el-option
          v-for="item in deliverySubList"
          :key="item.id"
          :label="item.deliveryName"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-date-picker
        v-model="formSearch.formdate"
        class="filter-item"
        type="monthrange"
        range-separator="至"
        value-format="yyyyMMdd"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <el-button @click="handleReset">重置</el-button>
      <el-button @click="handleSearch" type="primary">查询</el-button>
    </div>
    <el-table
      id="rebateSetTable"
      ref="table"
      :border="true"
      :data="dataSource"
      show-summary
      :max-height="tableHeight"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
      size="small"
    >
      <el-table-column
        v-for="item in columns"
        :prop="item.key"
        :label="item.name"
        :key="item.name"
        align="center"
        :width="columns.length > 15 ? item.width : ''"
      >
        <template slot="header" v-if="item.iconshow">
          <span
            >{{ item.name }}
            <el-tooltip
              effect="dark"
              :content="item.message"
              placement="top-start"
            >
              <i class="el-icon-info"></i> </el-tooltip
          ></span>
        </template>
        <el-table-column
          :prop="item.key"
          :label="`${item.value}${item.percent ? item.percent : ''}`"
          :width="item.width"
          :key="item.name"
          align="center"
        >
          <template slot-scope="scope">
            <span
              >{{ scope.row[item.key] ? item.unit : null
              }}{{ scope.row[item.key] ? scope.row[item.key] : "-"
              }}{{ scope.row[item.key] ? item.percent : null }}</span
            >
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { getPopuFetch, getDeliverySubList } from "@/api/api";
import moment from "moment";
export default {
  name: "MonthlyPop0",
  mounted() {
    this.getPopuData();
    this.getDeliveryList();
    let _this = this;
    window.onresize = () => {
      return _this.refresh();
    };
  },
  data() {
    return {
      columns: [],
      dataSource: [],
      loading: false,
      deliverySubList: [],
      formSearch: {
        formdate: [
          moment().subtract(6, "month").startOf("month").format("YYYYMMDD"),
          moment().subtract(1, "month").startOf("month").format("YYYYMMDD"),
        ],
        deliverySubIds: [],
      },
      pickerOptions: {
        disabledDate: function (date) {
          const currentDate = moment(date).format("yyyyMMDD");
          const today = moment(new Date()).format("yyyyMMDD");
          return !moment(currentDate).isBefore(today, "month");
        },
      },
      tableHeight: window.innerHeight - 200,
    };
  },
  methods: {
    getPopuData() {
      this.loading = true;
      getPopuFetch({
        startTime: this.formSearch.formdate
          ? this.formSearch.formdate[0]
          : null,
        endTime: this.formSearch.formdate ? this.formSearch.formdate[1] : null,
        deliverySubIds: this.formSearch.deliverySubIds.join(","),
      }).then((res) => {
        const { headers, popuMap, code } = res;
        this.loading = false;
        if (code === "0000") {
          this.columns = [];
          this.dataSource = [];
          if (Object.keys(popuMap).length == 0) {
            return;
          }
          // this.columns = headers;
          headers.map((item) => {
            this.columns.push({
              key: item,
              name: item,
              value: item == "渠道" ? "总计" : popuMap["总计"][item],
            });
          });
          for (let item in popuMap) {
            if (item !== "总计") {
              this.dataSource.push(
                Object.assign({ 渠道: item }, popuMap[item])
              );
            }
          }
        }
      });
    },
    getDeliveryList() {
      getDeliverySubList({
        pageNum: 1,
        pageSize: 99999,
      }).then((res) => {
        this.deliverySubList = res.data.list;
      });
    },
    handleReset() {
      this.formSearch = {
        formdate: [
          moment().subtract(6, "month").startOf("month").format("YYYYMMDD"),
          moment().subtract(1, "month").startOf("month").format("YYYYMMDD"),
        ],
        deliverySubIds: [],
      };
      this.getPopuData();
    },
    handleSearch() {
      this.getPopuData();
    },
    refresh() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.page-popu {
  padding: 16px;
  height: calc(100vh - 100px);
  .heaer-text {
    padding: 0px;
    margin-bottom: 16px;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
  }
  .filter {
    margin-bottom: 16px;
    .filter-item {
      margin-right: 16px;
      width: 300px;
      margin-bottom: 10px;
      /deep/ .el-input__inner {
        height: 32px !important;
      }
      /deep/ .el-cascader__search-input {
        min-width: 15px;
      }
      /deep/ .el-tag {
        max-width: 210px;
      }
    }
  }
}
</style>
